export enum Condition {
  STUDENT = 'STUDENT',
  BANK = 'BANK',
}

export const Conditions = [
  { value: 'STUDENT', label: 'Studierende' },
  { value: 'BANK', label: 'Bank' },
];
